import { combineReducers } from 'redux';
import Homes from './Homes/reducer';
import Boxes from './Boxes/reducer';
import Brands from './Brands/reducer';
import Installers from './Installers/reducer';
import Products from './Products/reducer';
import Notifications from './Notifications/reducer';
import Issues from './Issues/reducer';
import Projects from './Projects/reducer';
import Users from './Users/reducer';

export default combineReducers({
    Users,
    Homes,
    Boxes,
    Brands,
    Products,
    Installers,
    Notifications,
    Issues,
    Projects
});



// WEBPACK FOOTER //
// ./environments/fhe/data/reducer.js